<template>
  <div class="todo-list">
    <todo
      v-for="todo in todos"
      :key="todo.id"
      :todo="todo"
      :readonly="readonly"
      class="todo-list__item"
      @todo-text-input="onTodoTextInput"
      @todo-delete="onTodoDelete"
      @todo-change-completed="onTodoChangeCompleted"
    />

      <div class="todo-list__footer">
        <button
          v-if="!readonly"
          class="todo-list__new-todo"
          :class="{ 'todo-list__new-todo--animate': todos.length === 0 }"
          @click="onTodoAdd"
        >
          +
        </button>
      </div>
  </div>
</template>

<script>
import Todo from '@/components/Todo'

export default {
  name: 'TodoList',

  components: {
    Todo
  },

  props: {
    todos: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onTodoAdd() {
      this.$emit('todo-add')
    },

    onTodoTextInput(data) {
      this.$emit('todo-text-input', data)
    },

    onTodoDelete(id) {
      this.$emit('todo-delete', id)
    },

    onTodoChangeCompleted(data) {
      this.$emit('todo-change-completed', data)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../css/vars.styl'
@import '../css/animations.styl'
@import '../css/mixins.styl'

.todo-list

  &__new-todo
    width 32px
    height @width
    border-radius 50%
    text-transform uppercase
    font-size 26px
    background $white
    transition $transition
    cursor pointer
    opacity: .5
    color $light
    position relative
    hover()

    &--animate
      animate_pulse($white)

  &__item
    &:not(:last-child)
      margin-bottom 12px

  &__footer
    text-align center
</style>
